import {DatePipe} from '@angular/common';
import {Component, OnInit, inject} from '@angular/core';
import {FilterService} from '../../../services/filter.service';
import {filter} from 'rxjs';

@Component({
  selector: 'app-filter-date-selection-display',
  templateUrl: './filter-date-selection-display.component.html',
  styleUrls: ['./filter-date-selection-display.component.scss'],
  standalone: true,
  imports: [DatePipe],
})
export class FilterDateSelectionDisplayComponent implements OnInit {
  private filterService = inject(FilterService);

  startDate: Date;
  endDate: Date;

  ngOnInit(): void {
    this.filterService.currentSelectionsChange$
      .pipe(
        filter(() => {
          return (
            this.filterService.currentSelections.startDate !== undefined &&
            this.filterService.currentSelections.endDate !== undefined
          );
        })
      )
      .subscribe(() => {
        this.startDate = this.filterService.startDate;
        this.endDate = this.filterService.endDate;
      });
  }
}
